import type { EvaluationPlanCategoryBundle } from '../types/evaluationPlan';
import {
  buildLearningContentScopeVersion,
  learningContentScopeVersionFromHead,
} from './learningContentCacheVersion';

export { learningContentScopeVersionFromHead as evaluationPlanScopeVersionFromHead };

type VersionedRow = { updated_at?: string | null };

/** 번들 신선도: 성취기준|평가계획 (`count:max(updated_at)`) */
export function buildEvaluationPlanBundleVersion(bundle: EvaluationPlanCategoryBundle): string {
  // Draft 타입에는 updated_at이 없지만 DB select 결과는 런타임에 포함된다.
  const standardsVersion = buildLearningContentScopeVersion(
    (bundle.standards ?? []) as ReadonlyArray<VersionedRow>
  );
  const plansVersion = buildLearningContentScopeVersion(
    (bundle.plans ?? []) as ReadonlyArray<VersionedRow>
  );
  return `${standardsVersion}|${plansVersion}`;
}

export function buildEvaluationPlanBundleVersionFromHeads(params: {
  standardsVersion: string;
  plansVersion: string;
}): string {
  return `${params.standardsVersion}|${params.plansVersion}`;
}

/**
 * 번들 버전 비교: 행 수는 정확히, max(updated_at)은 시각(ms)으로 비교.
 * (저장 직후 클라이언트 ISO `...Z` 와 DB `...+00:00` 표기 차이로 불필요한 재다운로드가 생기지 않게)
 */
export function isSameEvaluationPlanBundleVersion(a: string | null | undefined, b: string | null | undefined): boolean {
  if (!a || !b) return false;
  if (a === b) return true;
  const pa = a.split('|');
  const pb = b.split('|');
  if (pa.length !== pb.length) return false;
  return pa.every((part, i) => {
    const [ca, ...ra] = part.split(':');
    const [cb, ...rb] = pb[i].split(':');
    if (ca !== cb) return false;
    const ta = ra.join(':');
    const tb = rb.join(':');
    if (ta === tb) return true;
    const ma = Date.parse(ta);
    const mb = Date.parse(tb);
    return Number.isFinite(ma) && Number.isFinite(mb) && ma === mb;
  });
}
